import {
  flowIdSalesConversation,
  flowIdRiskAnalysisBE,
  flowIdRiskAnalysisNL,
  flowIdRiskAnalysisShortBE,
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
  flowIdDeMotoVerzekering,
  flowIdVillasureOfferFlow,
  flowIdVillasureContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdPiaBoatContractFlow,
  flowIdBikmoOfferFlow,
  flowIdBikmoContractFlow,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdShortCheckupCompanyNL,
  flowIdShortCheckupCustomerNL,
  flowIdCfVerzekeringen,
  flowIdAskaTravelContract,
  flowIdAskaTravelOffer,
  flowIdShortCheckupCompanyBE,
  flowIdShortCheckupCustomerBE,
  flowIdGoudseCompanyScan,
} from '../../constants/flowIds';
import advisoryFlowInputComponentsConfig, {
  fullWidthConfig,
} from '../ui/advisory-flow/config/inputComponentsConfig';
import riskAnalysisFlowInputComponentsConfig from '../ui/risk-analysis/config/inputComponentsConfig';
import companyScanInputComponentsConfig from '../ui/company-scan/config/inputComponentsConfig';
import { Inputs } from '../../types/Enums';
import { InputConfig } from '../../types/ConfigTypes';

export const inputConfig = {
  [flowIdRiskAnalysisNL]: riskAnalysisFlowInputComponentsConfig,
  [flowIdRiskAnalysisBE]: riskAnalysisFlowInputComponentsConfig,
  [flowIdRiskAnalysisShortBE]: riskAnalysisFlowInputComponentsConfig,
  [flowIdSalesConversation]: {
    ...advisoryFlowInputComponentsConfig,
    [Inputs.MULTISELECT]: fullWidthConfig,
  },
  [flowIdCompanyScanBE]: companyScanInputComponentsConfig,
  [flowIdCompanyScanNL]: companyScanInputComponentsConfig,
  [flowIdGoudseCompanyScan]: companyScanInputComponentsConfig,
  [flowIdDeMotoVerzekering]: advisoryFlowInputComponentsConfig,
  [flowIdVillasureOfferFlow]: advisoryFlowInputComponentsConfig,
  [flowIdVillasureContractFlow]: advisoryFlowInputComponentsConfig,
  [flowIdPiaBoatOfferFlow]: advisoryFlowInputComponentsConfig,
  [flowIdPiaBoatContractFlow]: advisoryFlowInputComponentsConfig,
  [flowIdBikmoOfferFlow]: advisoryFlowInputComponentsConfig,
  [flowIdBikmoContractFlow]: advisoryFlowInputComponentsConfig,
  [flowIdCyclingVlaanderenContractFlowId]: advisoryFlowInputComponentsConfig,
  [flowIdCyclingVlaanderenOfferFlowId]: advisoryFlowInputComponentsConfig,
  [flowIdShortCheckupCompanyNL]: advisoryFlowInputComponentsConfig,
  [flowIdShortCheckupCompanyBE]: advisoryFlowInputComponentsConfig,
  [flowIdShortCheckupCustomerNL]: riskAnalysisFlowInputComponentsConfig,
  [flowIdShortCheckupCustomerBE]: riskAnalysisFlowInputComponentsConfig,
  [flowIdCfVerzekeringen]: advisoryFlowInputComponentsConfig,
  [flowIdAskaTravelContract]: advisoryFlowInputComponentsConfig,
  [flowIdAskaTravelOffer]: advisoryFlowInputComponentsConfig,
};

export const getInputConfig = (flowId: string): InputConfig => {
  return inputConfig[flowId] || advisoryFlowInputComponentsConfig;
};
